import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons";

/**
 * Bouton « Documents » réutilisable : ouvre les documents VosFactures
 * (devis, factures, avoirs) dans un nouvel onglet — même comportement que
 * le dropdown Documents de la fiche commande.
 *
 * Props :
 *  - documents : [{ url, name }] (cf. order.info.document_urls)
 *  - size, variant : passthrough vers le Dropdown.Toggle
 *  - stopPropagation : true pour ne pas déclencher le onClick d'une carte
 */
const DocumentsButton = ({
  documents = [],
  size = "sm",
  variant = "outline-secondary",
  stopPropagation = false,
}) => {
  if (!documents || documents.length === 0) {
    return null;
  }

  const stop = (e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  return (
    <Dropdown style={{ display: "inline-block" }} onClick={stop}>
      <Dropdown.Toggle variant={variant} size={size} id="documents-btn">
        <FontAwesomeIcon icon={faFileInvoice} /> Documents
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {documents.map((document, index) => (
          <Dropdown.Item
            key={index}
            href={document.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={stop}
          >
            {document.name || `Document ${index + 1}`}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DocumentsButton;
